module.exports = __webpack_public_path__ + "kr.5adfd676.svg";